/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable max-len */
import moment from 'moment-timezone';
import { ENCRYPT_SECERET_KEY } from '../redux/apiConstants';

const CryptoJS = require('crypto-js');

const viewerTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const dateFormatter2 = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  timeZone: viewerTimezone,
});

const dateFormatter4 = new Intl.DateTimeFormat('en-US', {
  hour: 'numeric',
  minute: 'numeric',
  hour12: true,
  timeZone: viewerTimezone,
});

/**
 * Extract calendar date YYYY-MM-DD from an event date value (ISO string or Date).
 * Prevents timezone shift: e.g. "2026-03-19T00:00:00.000Z" always yields "2026-03-19", not March 18 in US TZ.
 * For Date: uses UTC date parts when time is midnight UTC, else local date parts.
 */
export const getEventCalendarDateString = (value) => {
  if (value == null) return null;
  if (typeof value === 'string') {
    const trimmed = value.trim();
    const part = trimmed.slice(0, 10);
    if (part.length === 10 && /^\d{4}-\d{2}-\d{2}$/.test(part)) return part;
    const tPart = trimmed.split('T')[0];
    if (tPart && tPart.length === 10 && /^\d{4}-\d{2}-\d{2}$/.test(tPart)) return tPart;
    return null;
  }
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    const atUtcMidnight =
      value.getUTCHours() === 0 &&
      value.getUTCMinutes() === 0 &&
      value.getUTCSeconds() === 0 &&
      value.getUTCMilliseconds() === 0;
    const y = atUtcMidnight ? value.getUTCFullYear() : value.getFullYear();
    const m = atUtcMidnight ? value.getUTCMonth() : value.getMonth();
    const d = atUtcMidnight ? value.getUTCDate() : value.getDate();
    const mm = String(m + 1).padStart(2, '0');
    const dd = String(d).padStart(2, '0');
    return `${y}-${mm}-${dd}`;
  }
  return null;
};

/**
 * Format event date for display as MM-DD-YYYY without timezone shift.
 * Use for event start/end dates so the selected calendar day is always shown.
 */
export const formatEventDateDisplay = (value) => {
  const ymd = getEventCalendarDateString(value);
  if (!ymd) return '';
  const [y, m, d] = ymd.split('-').map(Number);
  const mm = String(m).padStart(2, '0');
  const dd = String(d).padStart(2, '0');
  return `${mm}-${dd}-${y}`;
};

const cancellationDateFormatter = new Intl.DateTimeFormat('en-US', {
  month: 'long',
  day: 'numeric',
  year: 'numeric',
});

/**
 * Format cancellation deadline date for display (e.g. "March 18, 2026") without timezone shift.
 * Uses calendar date from value so the selected day is shown correctly.
 */
export const formatCancellationDeadlineDisplay = (value) => {
  const ymd = getEventCalendarDateString(value);
  if (!ymd) return '';
  const [y, m, d] = ymd.split('-').map(Number);
  return cancellationDateFormatter.format(new Date(y, m - 1, d));
};

/** Returns date string in mm-dd-yyyy format for display in date fields. */
export const formatDateDisplay = (date) => {
  if (date == null || date === '') return '';
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return '';
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  const y = d.getFullYear();
  return `${m}-${day}-${y}`;
};

export const Encrypt = (value) => {
  const ciphertext = CryptoJS.AES.encrypt(value, ENCRYPT_SECERET_KEY).toString();
  // const encodedValue = encodeURIComponent(ciphertext);
  const encodedValue = ciphertext
    .replace(/\+/g, 'p1L2u3S')
    .replace(/\//g, 's1L2a3S4h')
    .replace(/=/g, 'e1Q2u3A4l');
  return encodedValue;
};
export const Decrypt = (value) => {
  // const decodeText = decodeURIComponent(value);
  const decodeText = value
    .replace(/p1L2u3S/g, '+')
    .replace(/s1L2a3S4h/g, '/')
    .replace(/e1Q2u3A4l/g, '=');
  const bytes = CryptoJS.AES.decrypt(decodeText, ENCRYPT_SECERET_KEY);
  const decodedValue = bytes.toString(CryptoJS.enc.Utf8);
  return decodedValue;
};

export const NumFormatter = (num) => {
  if (num > 999 && num < 1000000) {
    return `${(num / 1000).toFixed(2)}K`; // convert to K for number from > 1000 < 1 million
  }
  if (num > 1000000) {
    return `${(num / 1000000).toFixed(2)}M`; // convert to M for number from > 1 million
  }
  if (num < 900) {
    return num; // if value < 1000, nothing to do
  }
  return num;
};
// eslint-disable-next-line max-len
export const CapitalizeFirstLetter = (strs) => strs.charAt(0).toUpperCase() + strs.slice(1);

export const DateFormatter = (date, type) => {
  if (date == null || date === '') {
    if (type === 'toEventDate' || type === 'toEventViewDate') return '';
  }
  const newDate = new Date(date);
  switch (type) {
    case 'toString':
      return newDate.toString(); // Fri Jul 02 2021 14:03:54 GMT+0100 (British Summer Time)
    case 'toDateString':
      return newDate.toDateString(); // Fri Jul 02 2021
    case 'toLocaleString':
      return newDate.toLocaleString(); // 7/2/2021, 2:05:07 PM
    case 'toLocaleDateString':
      return newDate.toLocaleDateString(); // 7/2/2021
    case 'toGMTString':
      return newDate.toGMTString(); // Fri, 02 Jul 2021 13:06:02 GMT
    case 'toUTCString':
      return newDate.toUTCString(); // Fri, 02 Jul 2021 13:06:28 GMT
    case 'toISOString':
      return newDate.toISOString(); // 2021-07-02T13:06:53.422Z
    case 'toEventDate': {
      const ymd = getEventCalendarDateString(date);
      if (ymd) {
        const [y, m, d] = ymd.split('-').map(Number);
        return dateFormatter2.format(new Date(y, m - 1, d));
      }
      return dateFormatter2.format(newDate);
    }
    case 'toEventViewDate': {
      const formatted = formatEventDateDisplay(date);
      if (formatted) return formatted;
      return formatDateDisplay(newDate);
    }
    case 'toTime':
      return dateFormatter4.format(newDate);
    default:
      return newDate;
  }
};

export const formatTime = (time) => {
  if (typeof time !== 'string' || time.trim() === '') {
    return '';
  }
  const [hours, minutes] = time.split(':').map(Number);
  let period = 'AM';

  let adjustedHours = hours;
  if (hours >= 12) {
    period = 'PM';
    adjustedHours = hours > 12 ? hours - 12 : hours;
  }
  if (hours === 0) {
    adjustedHours = 12;
  }

  const formattedTime = `${adjustedHours}:${minutes < 10 ? `0${minutes}` : minutes} ${period}`;
  return formattedTime;
};

/**
 * Returns the short timezone abbreviation for an IANA timezone string using moment-timezone.
 * Correctly handles DST transitions.
 * Examples: "Asia/Kolkata" → "IST", "America/New_York" → "EST" / "EDT"
 * Falls back to empty string for unknown or invalid timezones.
 */
export const getTimezoneAbbr = (ianaTimezone) => {
  if (!ianaTimezone) return '';
  try {
    return moment.tz(ianaTimezone).zoneAbbr() || '';
  } catch {
    return '';
  }
};

/**
 * Formats a date value in the event's timezone as MM-DD-YYYY.
 * Uses moment.tz() so the UTC timestamp is converted to the event timezone before
 * extracting the calendar date — prevents date-shift when the stored timestamp is
 * the UTC equivalent of midnight in the event timezone
 * (e.g. "2026-03-18T18:30:00.000Z" is 2026-03-19 in Asia/Kolkata).
 *
 * Falls back to the raw string extraction when no timezone is provided.
 */
export const formatEventDateTz = (dateValue, ianaTimezone) => {
  if (!dateValue) return '';
  try {
    if (ianaTimezone) {
      const m = moment.tz(dateValue, ianaTimezone);
      if (m.isValid()) return m.format('MM-DD-YYYY');
    }
    // Fallback: extract YYYY-MM-DD from string directly (avoids browser-TZ shift)
    const ymd = getEventCalendarDateString(dateValue);
    if (ymd) {
      const [y, mo, d] = ymd.split('-').map(Number);
      return `${String(mo).padStart(2, '0')}-${String(d).padStart(2, '0')}-${y}`;
    }
    return '';
  } catch {
    return '';
  }
};

const dayOrdinalSuffix = (dayOfMonth) => {
  const n = dayOfMonth;
  const j = n % 10;
  const k = n % 100;
  if (k >= 11 && k <= 13) return 'th';
  if (j === 1) return 'st';
  if (j === 2) return 'nd';
  if (j === 3) return 'rd';
  return 'th';
};

/**
 * Event calendar date in the show timezone, e.g. "08th April 2026" (same TZ rules as formatEventDateTz).
 */
export const formatEventDateOrdinalTz = (dateValue, ianaTimezone) => {
  if (!dateValue) return '';
  try {
    if (ianaTimezone) {
      const m = moment.tz(dateValue, ianaTimezone);
      if (!m.isValid()) return '';
      const d = m.date();
      const dayPadded = String(d).padStart(2, '0');
      return `${dayPadded}${dayOrdinalSuffix(d)} ${m.format('MMMM')} ${m.format('YYYY')}`;
    }
    const ymd = getEventCalendarDateString(dateValue);
    if (ymd) {
      const [y, mo, d] = ymd.split('-').map(Number);
      const m = moment({ year: y, month: mo - 1, date: d });
      if (!m.isValid()) return '';
      const dayPadded = String(d).padStart(2, '0');
      return `${dayPadded}${dayOrdinalSuffix(d)} ${m.format('MMMM')} ${y}`;
    }
    return '';
  } catch {
    return '';
  }
};

/**
 * Formats an HH:MM time string with the event timezone abbreviation appended.
 * Example: formatEventTime("19:00", "Asia/Kolkata") → "7:00 PM IST"
 * The timeStr is already stored in the event's timezone so no conversion is needed —
 * we only append the correct abbreviation from moment-timezone.
 */
export const formatEventTime = (timeStr, ianaTimezone) => {
  const formatted = formatTime(timeStr);
  if (!formatted) return '';
  const abbr = getTimezoneAbbr(ianaTimezone);
  return abbr ? `${formatted} ${abbr}` : formatted;
};

export const formatTimeInTz = (dateValue, ianaTimezone, tzCode) => {
  if (!dateValue) return '';
  try {
    if (ianaTimezone) {
      const m = moment.tz(dateValue, ianaTimezone);
      if (m.isValid()) {
        const timeStr = m.format('h:mm A');
        const code = tzCode || m.zoneAbbr();
        return code ? `${timeStr} ${code}` : timeStr;
      }
    }
    // Fallback: browser local time
    const d = new Date(dateValue);
    if (Number.isNaN(d.getTime())) return '';
    return new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    }).format(d);
  } catch {
    return '';
  }
};
